import React, { useState, useEffect, useCallback } from "react";
import ListSearch from "../../components/custom/searches/ListSearch";
import Maper from "../../components/common/Maper";
import { mkSchool } from "../../assets/images";
import { USER_DATA } from "../../helpers/constants";
import Select from "react-select";
import { getSchools } from "../../services/schoolService";
import {getFormations} from "../../services/formationService"
import Filter from "../../components/common/Filter";
import premium from "../../assets/fonts/premium.svg";

// import data
import {
    COUNTRIES,
    DIPLOMES,
    FORMATIONS_DURATIONS,
    LANGUES,
    SECTORS,
} from "../../helpers/dummies";

const Searches = ({ partenary }) => {
    const [userName, setUserName] = useState("");
    const [isLogin, setIsLogin] = useState("");
    const [dataCount, setDataCount] = useState(0);
    const [zIndex, setZIndex] = useState("");

    const customStyles = {
        control: (provided) => ({
            ...provided,
            border: "none",
            boxShadow: "none",
        }),
    };

    //the core data from the api without any filter apply on
    const [searchListData, setSearchListData] = useState([]);

    //store data for select input
    const [selectDiplomes, setSelectDiplomes] = useState("");
    const [selectSectors, setSelectSectors] = useState("");
    const [selectCountries, setSelectCountries] = useState("");
    const [selectLangues, setSelectLangues] = useState("");
    const [selectFormationsDurations, setSelectFormationsDurations] = useState("");
    const [selectOrdination, setSelectOrdination] = useState("");

    //result after filter the data with the selects
    const [filteredResults, setFilteredResults] = useState([]);

    //handle select onChange for each select
    const handleDiplomesChange = (selectedOption) => {
        setSelectDiplomes(selectedOption);
    };
    const handleSectorsChange = (selectedOption) => {
        setSelectSectors(selectedOption);
    };
    const handleCountriesChange = (selectedOption) => {
        setSelectCountries(selectedOption);
    };
    const handleLanguesChange = (selectedOption) => {
        setSelectLangues(selectedOption);
    };
    const handleFormationsDurationsChange = (selectedOption) => {
        setSelectFormationsDurations(selectedOption);
    };

    const handleOrdinationChange = (selectedOption) => {
        setSelectOrdination(selectedOption);
    };

    //function for fetching data in api
    const getSchoolsData = async () => {
        try {
            const response = await getSchools();
            const { data } = response;
            setSearchListData(data);
            
        } catch (error) {
            console.error(error);
        }
    };

    //call the function when the component is rendering
    useEffect(() => {
        getSchoolsData();
    }, []);

    useEffect(() => {
        try {
            const userData = JSON.parse(localStorage.getItem(USER_DATA));
            const userPseudo = userData.name?.split(" ");
            const userName = userPseudo[1];

            setIsLogin(userData ? true : false);

            setUserName(userName);
        } catch (error) {
            console.log(error);
        }
    }, []);

    const applyFilters = useCallback(() => {
        let filteredData = searchListData;
        console.log("filteredData",filteredData)

        if (selectCountries) {
            const selectedCountry = selectCountries.label.toLowerCase();
            filteredData = filteredData.filter((school) =>
                school.country.name.toLowerCase().includes(selectedCountry)
            );
        }

        if (selectDiplomes) {
            const selectedFormationLevel = selectDiplomes.label.toLowerCase();
            filteredData = filteredData.filter((school) =>
                school.formations.some((formation) => formation.formationLevel.toLowerCase().includes(selectedFormationLevel))
            );
        }


        // Function to check if selected language matches any word in formationLanguage
        const languageMatches = (formationLanguage, selectedLanguage) => {
            if (!formationLanguage || !selectedLanguage) {
                return false;
            }

            // Split formationLanguage into individual words
            const formationWords = formationLanguage.split(/\s+/);

            // Split selectedLanguage into individual words
            const selectedWords = selectedLanguage.split(/\s+/);

            // Check if each selected word is present in formationLanguage
            const isMatch = selectedWords.every(
                (selectedWord) =>
                    formationWords.some(
                        (formationWord) => formationWord.toLowerCase() === selectedWord.toLowerCase()
                    )
            );

            return isMatch;
        };

        if (selectLangues) {
            const selectedLanguage = selectLangues.label.toLowerCase().trim();
            filteredData = filteredData.filter((school) =>
                school.formations.some((formation) => {
                    const formationLanguage = formation.language?.toLowerCase().trim();
                    return languageMatches(formationLanguage, selectedLanguage);
                })
            );
        }


        if (selectFormationsDurations) {
            const selectedDuration = selectFormationsDurations.label;
            filteredData = filteredData.filter((school) =>
                school.formations.some((formation) => formation.trainingDuration === selectedDuration)
            );
        }

        if (selectOrdination) {
            const sortOrder = selectOrdination.value === "asc" ? 1 : -1;
            filteredData.sort((a, b) =>
                a.note > b.note ? sortOrder : b.note > a.note ? -sortOrder : 0
            );
        }

        if (selectOrdination && selectOrdination.value === "desc") {
            filteredData.sort((a, b) => a.name.localeCompare(b.name));
        } else {
            filteredData.sort((a, b) => b.name.localeCompare(a.name));
        }

        setFilteredResults(filteredData);
    }, [searchListData, selectDiplomes, selectSectors, selectCountries, selectLangues, selectFormationsDurations, selectOrdination]);


    useEffect(() => {
        applyFilters();
    }, [applyFilters]);

    //reset all select input

    const resetFilter = () => {
        setSelectDiplomes("");
        setSelectSectors("");
        setSelectCountries("");
        setSelectLangues("");
        setSelectFormationsDurations("");
        setSelectOrdination("");
    };

    //set dataCount when not and when filtering data from API
    useEffect(() => {
        if (filteredResults && filteredResults.length) {
            setDataCount(filteredResults.length);
        } else {
            setDataCount(searchListData.length);
        }
    }, [filteredResults, searchListData.length]);

    // When clicked outside the Maper set z-index to -1 otherwise z-index should === 1;
    const handleClickOutside = (e) => {
        if (e.target.id === "searches-map") {
            setZIndex("-1");
        } else {
            setZIndex("1");
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
  console.log({userName})
    return (
        <React.Fragment>
            <div id="searches-layout">
                <div className="container searches-content pt-16">
                    <div className="flex justify-between items-center text-ace-ace_title mt-4">
                        <p className="lg:text-lg font-normal">Filtrez vos résultats</p>
                        <button
                            type="button"
                            className="rounded-md  bg-opacity-5 px-2 md:px-4 py-2"
                            onClick={resetFilter}
                        >
                            Effacer tous les filtres
                        </button>
                    </div>

                    <div className="w-full py-3 z-30">
                        <Filter withShadow>
                            <div className="d-flex">
                                <Select
                                    placeholder="Niveau d'étude"
                                    className="w-100 b-none"
                                    options={DIPLOMES}
                                    value={selectDiplomes}
                                    onChange={handleDiplomesChange}
                                    isClearable
                                    styles={customStyles}
                                />
                                <Select
                                    placeholder="Filière"
                                    className="w-100 b-none"
                                    options={SECTORS}
                                    value={selectSectors}
                                    onChange={handleSectorsChange}
                                    isClearable
                                    styles={customStyles}
                                />
                                <Select
                                    placeholder="Ville ou  pays"
                                    className="w-100 b-none"
                                    options={COUNTRIES}
                                    value={selectCountries}
                                    onChange={handleCountriesChange}
                                    isClearable
                                    styles={customStyles}
                                />
                                <Select
                                    placeholder="Langues"
                                    className="w-100 b-none"
                                    options={LANGUES}
                                    value={selectLangues}
                                    onChange={handleLanguesChange}
                                    isClearable
                                    styles={customStyles}
                                />
                                <Select
                                    placeholder="Durée de la formation"
                                    className="w-100 b-none"
                                    options={FORMATIONS_DURATIONS}
                                    value={selectFormationsDurations}
                                    onChange={handleFormationsDurationsChange}
                                    isClearable
                                    styles={customStyles}
                                />
                            </div>
                        </Filter>
                    </div>
                    <div>
                        <div className="flex flex-col-reverse md:flex-row md:justify-between items-start md:items-center mb-3 text-ace-dark_gray">
                            {isLogin ? (
                                <p className="text-xs md:text-lg">
                                    {`${userName}, nous avons trouvé`}{" "}
                                    <span className="font-semibold">{filteredResults?.length} formations</span>{" "}
                                    pour vous!
                                </p>
                            ) : (
                                <p>Veuillez vous connecter pour voir les formations.</p>
                            )}
                            <div className="w-full z-20 md:w-auto flex justify-between items-center space-x-2 pb-3 md:pb-0 text-md md:text-lg">
                                <span className="ordination w-1/2 text-center md:w-auto px-8 md:px-0 py-2.5 bg-white md:py-0 shadow-md md:shadow-none rounded-md md:rounded-none md:flex justify-center items-center">
                                    Ordination<span className="hidden md:flex">:</span>
                                </span>{" "}
                                <Select
                                    placeholder="Ordination"
                                    className="w-48"
                                    options={[
                                        { value: "asc", label: "Croissant" },
                                        { value: "desc", label: "Décroissant" },
                                    ]}
                                    value={selectOrdination}
                                    onChange={handleOrdinationChange}
                                    isClearable
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-6">
                        <div className="searches-map">
                            <Maper
                                withPopup
                                icon={mkSchool}
                                items={filteredResults}
                                redirectLink="/schools"
                                zIndex={zIndex}
                            />
                        </div>
                        <div className="searches-list">
                            {filteredResults.map((data) => {
                                const firstFormation = data.formations;
                                console.log("formation",firstFormation)
                                console.log("note",data.note)
                                const isPrivateSchool = !partenary && data.partenary === 0;
                                const shouldShowOverlay = data !== 1;

                                return (
                                    <React.Fragment key={`school_item_${data.id}`}>
                                        {isPrivateSchool && shouldShowOverlay ? (
                                            <div className="relative w-full mb-4">
                                                <ListSearch
                                                    name={data.name}
                                                    flag={data.country.flag}
                                                    city={data.city}
                                                    country={data.country.name}
                                                    publicId={data.publicId}
                                                    recognizedByState={data.recognizedByState}
                                                    annualBackToSchool={data.annualBackToSchool}
                                                    formationName={firstFormation ? firstFormation.name : ""}
                                                    trainingDuration={firstFormation ? firstFormation.trainingDuration : ""}
                                                    language={firstFormation ? firstFormation.language : ""}
                                                    teachingMode={firstFormation ? firstFormation.teachingMode : ""}
                                                    note={data.note ? data.note :""}
                                                />
                                                {/* <div className='w-full absolute top-0 left-0 z-10 flex items-center space-x-3 p-3'>
                                                    <img src={data.country.flag} alt={data.country.name} className='w-10 h-6' />
                                                    <p className='text-[#505050] text-lg font-semibold'>{data.city}</p>
                                                </div>
                                                <div className="w-full absolute flex flex-1 justify-center items-center top-0 left-0 h-full flex-col backdrop-filter backdrop-blur-lg bg-opacity-30 rounded-xl">
                                                    <div className='w-full flex space-x-2 justify-center items-center'>
                                                        <img src={premium} alt="premium" className="w-8" />
                                                        <p className="text-[#005073] text-lg font-semibold">Premium Content</p>
                                                    </div>
                                                </div> */}
                                            </div>
                                        ) : (
                                          <ListSearch
                                                name={data.name}
                                                flag={data.country.flag}
                                                city={data.city}
                                                country={data.country.name}
                                                publicId={data.publicId}
                                                recognizedByState={data.recognizedByState}
                                                annualBackToSchool={data.annualBackToSchool}
                                                formationName={firstFormation ? firstFormation.name : ""}
                                                trainingDuration={firstFormation ? firstFormation.trainingDuration : ""}
                                                language={firstFormation ? firstFormation.language : ""}
                                                teachingMode={firstFormation ? firstFormation.teachingMode : ""}
                                                note={data.note}
                                            />
                                            
                                        )}
                                    </React.Fragment>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Searches;